import { RightIcon } from "Components/GitCard/images";
import { memo } from "react";

import "./card.scss";

const Card = ({ icon, title, urlTitle, url }) => {
  return (
    <div className="git-card-container">
      <div className="git-card">
        <div className="icon">{icon}</div>
        <div className="git-card-title">
          <h4>{title}</h4>
        </div>
        {/* <div className="url"> */}
        <a href={url} className="url" target="blank">
          {urlTitle}
          <span className="card-right-icon">
            <RightIcon />
          </span>
        </a>
        {/* </div> */}
      </div>
    </div>
  );
};

export default memo(Card);
